const en = {
  loading: 'Loading ...',
  not_found: 'Record is not found',
  error_occurred: 'Unexpected error is encountered. Please try again',

  add_new_ticket_type: 'Add a new ticket type',
  add: 'Add',
  update: 'Update',
  agree: 'Agree',
  confirm: 'Confirm',
  save: 'Save',
  cancel: 'Cancel',
  attention: 'Attention',
  name: 'Name',
  surname: 'Surname',
  icon: 'Icon',
  currencies: 'Currencies',

  description: 'Description',
  payment_types: 'Types of Payment',
  delete: 'Delete',
  reservation_date: 'Reservation date',
  user: 'User',
  paid_date: 'Payment date',
  ticket_types: 'Ticket types',

  delete_confirmation_message: 'Are you sure you want to delete?',
  delete_message: 'Do you want to continue the deletion?',
  delete_success_message: 'Record is deleted successfully',

  create_success_message: 'Record is created successfully',
  update_success_message: 'Record is updated successfully',

  email: 'Email',
  address: 'Address',
  phone: 'Telephone',
  required: 'This area is mandatory',
  close: 'close',
  group_drag_field_description: 'Drag from the column head to group the column and leave here.',
  branchs: 'Branchs',
  countries: 'Countries',

  search: 'Search ...',

  prefix: 'Prefix',
  branch: 'Branch',
  ticket_type: 'Ticket Type',
  comission_rate: 'Comission Rate',
  code_length: 'Code Length',
  current_index: 'Current Index',

  code: 'Code',
  picture: 'Picture',
  name_surname: 'Name Surname',
  username: 'Username',
  password: 'Password',
  confirm_password: 'Confirm Password',

  employee: 'Employee',
  customer: 'Customer',
  total_amount: 'Total Amount',
  deposit: 'Deposit',
  rest: 'Rest',
  currency: 'Currency',
  status: 'Status',

  validation: {
    required: '{{field}} is a required field',
    email: 'Please enter a valid email',
  },
  table_search: 'Search',

  menu: {
    pdf_design:'Pdf Design',
    dashboard: 'Dashboard',
    branches: 'Branches',
    branch_comissions: 'Branch Commissions',
    middlemen: 'Middlemen',
    middleman_sales: 'Middleman Sales',
    employees: 'Employee Management',
    tickets: 'Ticket Management',
    transfers: 'Transfers',
    sales: 'Sales Management',
    money_flow: 'Moneyflow',
    premium_payments: 'Premium Payments',
    settings: 'System Settings',
    currencies: 'Currencies',
    payment_types: 'Payment Types',
    ticket_types: 'Ticket Types',
    ticket_numbers: 'Ticket Numbers',
    comission_percentages: 'Comission Percentages',
    countries: 'Countries',
  },
};
export default en;
